import styles from "../../assets/css/pane.module.scss";
import AppSkeleton from "../../components/Skeletons/AppSkeleton";
import { baseColor, highlightColor } from "../../constants/skeletonColor";

const SkeletonBox = ({
  circleRadius = 70,
  primaryLineWidth = 400,
  secondaryLineWidth = 200,
}) => {
  return (
    <div className={styles.skeletonBox}>
      <div>
        <AppSkeleton
          height={circleRadius}
          width={circleRadius}
          variant="circular"
          // baseColor={baseColor}
          // highlightColor={highlightColor}
        />
      </div>
      <div className={styles.skeletonRight}>
        <AppSkeleton
          height={25}
          width={primaryLineWidth}
          // baseColor={baseColor}
          // highlightColor={highlightColor}
        />
        <AppSkeleton
          height={15}
          width={secondaryLineWidth}
          // baseColor={baseColor}
          // highlightColor={highlightColor}
        />
      </div>
    </div>
  );
};
export default SkeletonBox;
